<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <component-header
                    title="Coupon Code"
                    :isLoading="loading"
                    @reload-data="getCouponCodeList"
                    @create-press="$router.push({ name: 'Createcoupon' })"
                    :hasSearch="false"
                    :hasClear="false"
                />
            </b-col>
        </b-row>

        <b-card class="card-wrap mt-2" border-variant="info">
            <!-- Filters -->
            <b-row class="mt-3">
                <b-col md="3" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <eb-input
                            label="Coupon Code"
                            id="couponCode"
                            placeholder="Coupon Code"
                            v-model="filterCouponCode"
                            type="text"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="3" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <label>Time Period</label>
                        <eb-select
                            type="select"
                            v-model="selectedPeriod"
                            :options="periodList"
                            label="text"
                            :id="'selecttime'"
                            @input="changePeriod"
                            :selected="selectedPeriod"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="3" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <label>Select Provider</label>
                        <eb-select
                            type="select"
                            v-model="selectedProvider"
                            :options="partnerList"
                            label="partnerName"
                            id="selectprovider"
                            :selected="selectedProvider"
                            placeholder="Select Provider"
                            @input="changeProvider"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="3" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <label>Status</label>
                        <eb-select
                            type="select"
                            v-model="selectedStatus"
                            :options="['ALL', 'PENDING APPROVAL', 'APPROVED']"
                            :id="'selectstatus'"
                            :selected="selectedStatus"
                            placeholder="Select Status"
                            @input="getCouponCodeList"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Table -->
            <div class="mt-2">
                <b-table
                    :dark="dark"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive
                    id="my-table"
                    :filter="filterCouponCode"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="couponcodeList"
                    thead-class="header"
                    class="mt-3"
                    :fields="Columns"
                    show-empty
                    @filtered="onFilter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(action)" slot-scope="data">
                        <b-button
                            size="sm"
                            class="mr-2 button-circle"
                            variant="primary"
                            @click="navigateTo(data.item, 'view')"
                        >
                            <i class="fa fa-eye"></i>
                        </b-button>
                        <b-button
                            size="sm"
                            class="mr-2 button-circle"
                            style="background: #fe7b08; border: #fe7b08"
                            variant="primary"
                            @click="navigateTo(data.item, 'edit')"
                        >
                            <i class="fa fa-pencil edit"></i>
                        </b-button>
                        <b-button
                            size="sm"
                            class="mr-2 button-circle"
                            variant="danger"
                            @click="deleteCouponcode(data)"
                        >
                            <i class="fa fa-trash bin"></i>
                        </b-button>
                    </template>

                    <template v-slot:empty="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                </b-table>
            </div>

            <!-- Pagination -->
            <div
                class="float: right mt-3"
                v-if="couponcodeList.length > perPage"
            >
                <b-pagination
                    v-model="currentPage"
                    :total-rows="couponcodeList.length"
                    :per-page="perPage"
                    size="md"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import Createcoupon from "@/components/MasterSetup/Coupon/Createcoupon";
import Editcoupon from "@/components/MasterSetup/Coupon/Editcoupon";
import Viewcoupon from "@/components/MasterSetup/Coupon/ViewCoupon";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import ebSelect from "@/components/FormElements/Select";
import ebInput from "@/components/FormElements/Input";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "Coupondetails",
    components: {
        ebButton,
        loader,
        Createcoupon,
        Editcoupon,
        Viewcoupon,
        ebSelect,
        ebInput,
        ComponentHeader,
    },
    data() {
        return {
            loading: false,
            perPage: 10,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            filterCouponCode: "",
            sortBy: "createdAt",
            sortDesc: true,
            selectedStatus: "ALL",
            selectedProvider: { partnerName: "ALL", _id: "" },

            Columns: [
                { key: "Coupon Code", label: "Coupon Code", sortable: true },
                { key: "Coupon value", label: "Coupon Value" },
                { key: "Start Date", label: "Start Date" },
                { key: "End Date", label: "End Date" },
                { key: "action", label: "Action" },
            ],

            selectedPeriod: { text: "Last 7 days", value: 7 },
            periodList: [
                { text: "Last 7 days", value: 7 },
                { text: "Last 15 days", value: 15 },
                { text: "Last 30 days", value: 30 },
                { text: "Last 3 Months", value: 90 },
                { text: "Last 6 Months", value: 180 },
            ],
        };
    },
    computed: {
        ...mapGetters({
            couponcode: "coupon/couponCodeList",
        }),
        couponcodeList() {
            const list = [];
            this.couponcode.forEach((data, i) => {
                list.push({
                    _id: data._id,
                    "Coupon Code": data.promoCode?.toUpperCase(),
                    "Coupon value": data.promoRules?.rewardValue,
                    "Start Date": moment(data.promoRules?.startDate).format(
                        "DD/MM/yyyy",
                    ),
                    "End Date": moment(data.promoRules?.endDate).format(
                        "DD/MM/yyyy",
                    ),
                    isApproved: data.isApproved,
                });
            });
            return list;
        },
        partnerList() {
            let data = this.$store.getters["partner/GetPartnerLiteList"];
            if (data?.length) {
                let partners = [{ partnerName: "ALL", _id: "" }];
                data.map((obj) => {
                    partners.push({
                        ...obj,
                        partnerName: obj.organization?.name,
                    });
                });
                return partners;
            }
            return [];
        },
    },
    methods: {
        ...mapActions({
            GetPartnerList: "partner/fetchPartnerListLite",
        }),

        async getCouponCodeList() {
            this.loading = true;
            try {
                const endDate = new Date();
                const startDate = new Date();
                startDate.setDate(
                    endDate.getDate() - this.selectedPeriod.value,
                );

                const payload = {
                    startDate: startDate.toISOString(),
                    endDate: endDate.toISOString(),
                };

                if (this.$userRole === "Tenant") {
                    if (this.selectedProvider && this.selectedProvider._id)
                        payload.providerId = this.selectedProvider._id;
                } else {
                    payload.providerId = this.$currentUserData._id;
                }

                if (this.selectedStatus !== "ALL")
                    payload.status = this.selectedStatus === "APPROVED";

                const res = await this.$store.dispatch(
                    "coupon/promotionListByFilter",
                    payload,
                );
            } catch (e) {
                console.error("Error fetching coupons:", e);
            } finally {
                this.loading = false;
            }
        },

        changeProvider() {
            this.getCouponCodeList();
        },
        changePeriod() {
            this.getCouponCodeList();
        },
        onFilter(list) {
            this.currentPage = 1;
        },

        navigateTo(data, type) {
            const coupon = this.couponCode.find((x) => x._id === data._id);
            if (type === "edit") {
                this.$router.push({
                    name: "Editcoupon",
                    params: { data: coupon },
                });
            } else if (type === "view") {
                this.$router.push({
                    name: "ViewCoupon",
                    params: { data: coupon },
                });
            }
        },

        deleteCouponcode(couponcode) {
            this.$swal({
                title: "Delete this coupon?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("coupon/deleteCouponcode", {
                            promoCode: couponcode.item.CouponCode,
                        })
                        .then(() => {
                            this.$toasted.success(
                                "Coupon Deleted Successfully",
                            );
                            this.getCouponCodeList();
                        });
                }
            });
        },
    },

    mounted() {
        this.getCouponCodeList();
        this.GetPartnerList({ type: "SELLER" });
    },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
